import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import classNames from 'classnames';
import React from 'react';
var defaultProps = {
  type: 'valid',
  as: 'div'
};
var Feedback = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var Component = _ref.as,
    className = _ref.className,
    type = _ref.type,
    props = _objectWithoutPropertiesLoose(_ref, ["as", "className", "type"]);
  return /*#__PURE__*/React.createElement(Component, _extends({}, props, {
    ref: ref,
    className: classNames(className, type && type + "-feedback")
  }));
});
Feedback.displayName = 'Feedback';
Feedback.defaultProps = defaultProps;
export default Feedback;